import type { FaireProductEntity } from "../../entity_types/product";

export const p_pkgx9p6x88: FaireProductEntity = {
  token: "p_pkgx9p6x88",
  type: "product",
  name: "Checkered Print Large Capacity Canvas Shoulder Bag",
  brandToken: "b_11782mgvt5",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e826180b8f9edcdd9c9183b10d787b109a07f1d0b19b2f1b0b00f1b7cc11e996.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/544519a70fdd5eaef46cf2fe8bf5bdebb28659b6933a3e4cd139c4f8e50b5f41.png",
  ],
  priceDollars: 11.23,
  description:
    "Material: 100%Polyester\nSize Chart (INCH)\t\t\t\nSize\t                  Length    \t   Height\t         Width\nONE SIZE\t20.9–21.1\t15.7–15.9\t0.8–1.2\n",
  tags: [],
  msrpDollars: 22.45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:14.887Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
